import { BatchDeterminationContext } from '../../../contexts/BatchDeterminationContext';
import { Filters } from '../../../interfaces/ImportHistory';
import { FILTERS, INITIAL_FILTERS } from '../../../shared/constants/ImportHistoryConstants';
import { getCodeFromStringValue, getStatusStringFromCode } from '../../../shared/helpers/importHistoryHelper';
import { SovosFilterDateInput, SovosFilterDrawer, SovosFilterTextEntry } from 'mosaic-react';
import { useContext, useEffect, useState } from 'react';

interface FiltersDrawerProps {
	isOpenFilters: boolean;
	onClose: () => void;
}

const FiltersDrawer = (props: FiltersDrawerProps) => {
	const { isOpenFilters, onClose } = props;
	const { filters, handleFiltersChange, processStatuses, profiles } = useContext(BatchDeterminationContext);
	const [localFilters, setLocalFilters] = useState<Filters>(filters);

	useEffect(() => {
		if (isOpenFilters) {
			setLocalFilters(filters);
		}
	}, [filters, isOpenFilters]);

	const handleOnSave = () => {
		handleFiltersChange(FILTERS.START_DATE, localFilters.startDate);
		handleFiltersChange(FILTERS.PROFILES, localFilters.profiles);
		handleFiltersChange(FILTERS.STATUS, localFilters.status);
		onClose();
	};

	return (
		<SovosFilterDrawer
			open={isOpenFilters}
			SaveButtonProps={{
				onClick: handleOnSave,
			}}
			ClearButtonProps={{
				onClick: () => setLocalFilters(INITIAL_FILTERS),
			}}
			onClose={onClose}
		>
			<SovosFilterDateInput
				data={localFilters.startDate.map(date => (date === '' ? null : date))}
				format='yyyy-MM-dd'
				label='Date'
				multiple
				onChange={(value: string[]) => setLocalFilters(localFilters => ({ ...localFilters, startDate: value }))}
			/>
			<SovosFilterTextEntry
				label='Status'
				autoComplete={processStatuses.map(itemStatus => itemStatus.status)}
				data={localFilters.status.map(codeStatus => getStatusStringFromCode(processStatuses, codeStatus))}
				onChange={(data: string[]) =>
					setLocalFilters(localFilters => ({
						...localFilters,
						status: data.map(status => getCodeFromStringValue(processStatuses, status)),
					}))
				}
				multiple
			/>
			<SovosFilterTextEntry
				label='Source'
				data={localFilters.profiles}
				autoComplete={profiles}
				onChange={(value: string[]) => setLocalFilters(localFilters => ({ ...localFilters, profiles: value }))}
				multiple
			/>
		</SovosFilterDrawer>
	);
};

export default FiltersDrawer;
